import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoLoraServersComponent } from './listado-lora-servers/listado-lora-servers.component';

const routes: Routes = [
  {
    path: '',
    component: ListadoLoraServersComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoraServersRoutingModule {}
